/**
 * @description
 * Hook to access authentication context.
 * Provides type-safe access to authentication state and methods.
 *
 * @author AI Developer <ai@byteable.ai>
 * @date January 6, 2025
 * @see /admin/src/lib/auth.ts
 */

import { useContext } from 'react';
import type { AuthContextValue } from '../../types/auth';

// Import the context from AuthContext.tsx
import { AuthContext } from '../contexts/AuthContext';

/**
 * Hook to access authentication context
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
}

/*
 * © 2025 Byte Inc. All rights reserved.
 * This code is the confidential and proprietary information of Byte Inc.
 * You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Byte Inc.
 */
